import Vue from "vue";
import Vuex from "vuex";
import * as mutation from "./mutation-types"
import * as action from "./action-types"
import router from "./router"
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

const vm = new Vue()

const state = {
    sideItems: [],
    sideInfo: {
        menu: null,
        submenu: null,
        article: null
    },
    searchHistory: []
}


for (let item in state) {
    sessionStorage.getItem(item) ? state[item] = JSON.parse(sessionStorage.getItem(item)) : false;
}
// console.log(state)
const mutations = {
    /* 设置sideItem信息 */
    [mutation.SIDE_ITEMS](state, sideItems) {
        state.sideItems = JSON.parse(JSON.stringify(sideItems))
        sessionStorage.setItem('sideItems', JSON.stringify(sideItems))
    },
    [mutation.SIDE_INFO](state, sideInfo) {
        state.sideInfo = JSON.parse(JSON.stringify(sideInfo))
        sessionStorage.setItem('sideInfo', JSON.stringify(sideInfo))
    },
    [mutation.SAVE_SEARCH_HISTORY](state, searchHistory) {
        state.searchHistory = JSON.parse(JSON.stringify(searchHistory))
        sessionStorage.setItem('searchHistory', JSON.stringify(searchHistory))
    },
    [mutation.CLEAR_SEARCH_HISTORY](state) {
        state.searchHistory = []
        sessionStorage.setItem('searchHistory', "")
    },
}
const actions = {}
const getters = {
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    plugins: [createPersistedState({
            filter: (mutation) => {
                // console.log(mutation)
            }
        })]
});
